import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles(() => ({
  audiences: {
    "& ::placeholder": {
      opacity: 1,
    },
    "& .Mui-focused ::placeholder": {
      opacity: 0.5,
    },
  },
}));
